// Fichier : Users.tsx
// Ce fichier définit le composant Users qui utilise useGetAllUsersQuery pour récupérer la liste des utilisateurs, convertit les données si nécessaire, et affiche une table de utilisateurs avec une option pour ajouter un nouvel utilisateur.

import Table from "./Table"; // Importation du composant Table pour afficher la liste des utilisateurs
import { useNavigate } from "react-router-dom"; // Importation de useNavigate pour la navigation
import { useGetAllUsersQuery } from "@/state/usersApiSlice"; // Importation de useGetAllUsersQuery pour interroger l'API des utilisateurs
import styles from "./Users.module.css"; // Importation des styles CSS spécifiques au composant Users
import { convertBooleansToStrings } from "@/utils/functions"; // Importation de la fonction utilitaire convertBooleansToStrings

const Users = () => {
  const { data: usersList, error, isLoading } = useGetAllUsersQuery(); // Récupération des données des utilisateurs à l'aide de useGetAllUsersQuery

  const navigate = useNavigate(); // Initialisation de la fonction de navigation

  // Transformation des données des utilisateurs si disponibles, en convertissant les boolean en chaînes de caractères (les Booleans sont non imprimables)
  const transformedUsersList = usersList
    ? convertBooleansToStrings(usersList)
    : [];

  // Affichage d'un message de chargement pendant le chargement des données
  if (isLoading) return <div>Loading...</div>;

  // Affichage d'un message d'erreur si une erreur se produit lors du chargement des données
  if (error) return <div>Error: </div>;

  // Rendu du composant Users avec la barre latérale, la table des utilisateurs et le bouton "Add New User" pour ajouter un nouvel utilisateur
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <button
          onClick={() => navigate("/users/add")}
          className={styles.button}
        >
          Add New User
        </button>
        <Table users={transformedUsersList} />
      </div>
    </div>
  );
};

export default Users;
